module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/page-down-a03a0ff9a52737ae4f17f3a09414884a.svg";